import { getIcons } from "./icons";

const controls = [
  {
    title: "轮播图",
    type: "carousel",
    config: {
      auto: false,
      delay: 3,
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      //   width: 375,
      height: 200,
      borderRadius: 8,
      backgroundColor: "transparent",
      imgList: [{ url: null, link: null }],
    },
  },
  {
    title: "文章列表",
    type: "article",
    config: {
      title: "",
      bold: true, // 标题是否加粗
      // itemLine: true, // 是否显示列表分割线
      topLine: false, // 是否显示大标题分割线
      more: {
        title: "更多",
        url: null,
      },
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      backgroundColor: "transparent",
      content: {
        padding: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
        },
        borderRadius: 8,
        backgroundColor: "#ffffff",
      },
      list: [],
      isShow: false,
    },
  },
  {
    title: "文件列表",
    type: "file",
    config: {
      title: "",
      bold: true, // 标题是否加粗
      itemLine: true, // 是否显示列表分割线
      topLine: false, // 是否显示大标题分割线
      more: {
        title: "更多",
        url: null,
      },
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      backgroundColor: "transparent",
      content: {
        padding: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
        },
        borderRadius: 8,
        backgroundColor: "#ffffff",
      },
      list: [],
      isShow: false,
    },
  },
  {
    title: "横幅",
    type: "banner",
    config: {
      url: null,
      img: null, // https://cms-1302345365.cos.ap-nanjing.myqcloud.com/20210325_605c5e9dd395b.png
      height: 150,
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      borderRadius: 8,
      backgroundColor: "transparent",
    },
  },
  //   {
  //     title: "嘉宾列表",
  //     type: "guest",
  //     config: {
  //       title: null,
  //       bold: true, // 标题是否加粗
  //       itemLine: true, // 是否显示列表分割线
  //       topLine: true, // 是否显示大标题分割线
  //       more: {
  //         title: "更多",
  //         url: null,
  //       },
  //       margin: {
  //         top: null,
  //         left: null,
  //         right: null,
  //         bottom: null,
  //       },
  //       padding: {
  //         top: 0,
  //         left: 10,
  //         right: 10,
  //         bottom: 10,
  //       },
  //       backgroundColor: "transparent",
  //       list: [],
  //       isShow: false,
  //     },
  //   },
  {
    title: "直播列表",
    type: "live",
    config: {
      title: null,
      bold: true, // 标题是否加粗
      // itemLine: true, // 是否显示列表分割线
      topLine: false, // 是否显示大标题分割线
      more: {
        title: "更多",
        url: null,
      },
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      height: 200,
      backgroundColor: "transparent",
      content: {
        padding: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
        },
        borderRadius: 8,
        backgroundColor: "#ffffff",
      },
      borderRadius: 8,
      list: [],
      isShow: false,
    },
  },
  //   {
  //     title: "标签页",
  //     type: "tabs",
  //     config: {
  //       line: true, // 是否显示标签与内容直接分割线
  //       bar: {
  //         show: true,
  //         color: "",
  //       },
  //       margin: {
  //         top: null,
  //         left: null,
  //         right: null,
  //         bottom: null,
  //       },
  //       padding: {
  //         top: 0,
  //         left: 0,
  //         right: 0,
  //         bottom: 0,
  //       },
  //       height: 48,
  //       backgroundColor: "tansparent",
  //       color: "",
  //       list: [{ title: null, controls: [] }],
  //     },
  //   },
  {
    title: "图标",
    type: "icons",
    config: {
      num: 3, // 一行的图标数量
      gap: {
        horizontal: 10, // 图标水平间距
        vertical: 10, // 图标垂直间距
      },
      color: "transparent", // 图标统一的颜色
      size: 2, // 图标大小 1小 2中 3 大
      margin: {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      padding: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      backgroundColor: "transparent",
      item: {
        padding: {
          top: 10,
          left: 10,
          right: 10,
          bottom: 10,
        },
        borderRadius: 8,
        backgroundColor: "#ffffff",
      },
      list: getIcons(),
    },
  },
];

export default controls;
